import { FC, useRef } from "react";
import { Trans } from "@lingui/macro";
import { includes } from "lodash-es";
import { FiltersWrapper } from "./DesktopFilter.styled";
import {
  COLOUR_FACET,
  PATTERN_FACET,
  PRICE_FACET,
  PROMOTION_FACET,
  SIZE_FACET,
  STYLE_FACET,
  BRAND_FACET,
  CONSCIOUS_FACET,
  DISCOUNT_FACET,
} from "src/utils/algolia";
import { DiscountRefinementList } from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/DiscountRefinementList";
import { DefaultRefinementList } from "./DefaultRefinementList";
import { ColorRefinementList } from "./ColorRefinementList";
import { PriceConnectRange } from "./PriceConnectRange";
import { PromotionConnectMenu } from "./PromotionConnectMenu";
import { BrandFilter } from "./BrandFilter";
import { ConsciousRefinementList } from "./ConsciousRefinementList";

interface Props {
  onClose: () => void;
  excludedFacetsList?: string[];
  currentIndex: number | null;
  switchFilters: (index: number, filterName: string) => () => void;
}

const FilterGrid: FC<Props> = ({
  onClose,
  excludedFacetsList,
  currentIndex,
  switchFilters,
}) => {
  const filtersRef = useRef(null);

  return (
    <FiltersWrapper ref={filtersRef}>
      {!includes(excludedFacetsList, BRAND_FACET) && (
        <BrandFilter
          attribute={BRAND_FACET}
          currentIndex={currentIndex}
          setCurrentIndex={(index) => switchFilters(index, BRAND_FACET)}
          outerRef={filtersRef}
          closeFilters={onClose}
          limit={200}
        />
      )}

      <ColorRefinementList
        attribute={COLOUR_FACET}
        filterIndex={1}
        setCurrentIndex={(index) => switchFilters(index, COLOUR_FACET)}
        outerRef={filtersRef}
        closeFilters={onClose}
        opened={currentIndex === 1}
        limit={100}
      />

      <DefaultRefinementList
        attribute={SIZE_FACET}
        label={<Trans>Size</Trans>}
        filterIndex={2}
        setCurrentIndex={(index) => switchFilters(index, SIZE_FACET)}
        outerRef={filtersRef}
        closeFilters={onClose}
        opened={currentIndex === 2}
        testid="filter-sizes"
        isMultiColumn={true}
        limit={100}
      />

      <PriceConnectRange
        filterIndex={3}
        setCurrentIndex={(index: number) => switchFilters(index, PRICE_FACET)}
        outerRef={filtersRef}
        closeFilters={onClose}
        opened={currentIndex === 3}
        attribute={PRICE_FACET}
        precision={2}
      />
      {!includes(excludedFacetsList, PROMOTION_FACET) && (
        <PromotionConnectMenu
          attribute={PROMOTION_FACET}
          filterIndex={4}
          setCurrentIndex={(index) => switchFilters(index, PROMOTION_FACET)}
          outerRef={filtersRef}
          closeFilters={onClose}
          opened={currentIndex === 4}
        />
      )}

      <DefaultRefinementList
        attribute={STYLE_FACET}
        label={<Trans>Style</Trans>}
        filterIndex={5}
        setCurrentIndex={(index) => switchFilters(index, STYLE_FACET)}
        outerRef={filtersRef}
        closeFilters={onClose}
        opened={currentIndex === 5}
        testid="filter-style"
        limit={20}
      />

      <DefaultRefinementList
        attribute={PATTERN_FACET}
        label={<Trans>Pattern</Trans>}
        filterIndex={6}
        setCurrentIndex={(index) => switchFilters(index, PATTERN_FACET)}
        outerRef={filtersRef}
        closeFilters={onClose}
        opened={currentIndex === 6}
        testid="filter-patterns"
        limit={20}
      />
      {!includes(excludedFacetsList, CONSCIOUS_FACET) && (
        <ConsciousRefinementList
          attribute={CONSCIOUS_FACET}
          filterIndex={8}
          setCurrentIndex={(index) => switchFilters(index, CONSCIOUS_FACET)}
          outerRef={filtersRef}
          closeFilters={onClose}
          opened={currentIndex === 8}
        />
      )}
      {!includes(excludedFacetsList, DISCOUNT_FACET) && (
        <DiscountRefinementList
          attribute={DISCOUNT_FACET}
          filterIndex={9}
          setCurrentIndex={(index) => switchFilters(index, DISCOUNT_FACET)}
          outerRef={filtersRef}
          closeFilters={onClose}
          opened={currentIndex === 9}
        />
      )}
    </FiltersWrapper>
  );
};

export { FilterGrid };
